/// <reference path="../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// RN + NativeWind mirror of the empty-state block defined inline in
// `apps/web/src/shell/hosts/ContactsRouteHost.tsx`. Rendered in the
// right column whenever no contact is selected. Matches Figma file
// Y95LG1oFzU2PHIvFuMYTfJ → Contacts page (541:65780).

import { UserPlus } from "lucide-react-native";
import { Pressable, Text, View } from "react-native";
import type { ContactsEmptyStateProps } from "./ContactsScreen.types";

export function ContactsEmptyState({
	onAddContact,
}: ContactsEmptyStateProps): JSX.Element {
	return (
		<View
			className="
				flex-1 flex flex-col items-center justify-center gap-md px-xl
				bg-light-surface-primary dark:bg-[#0A0B0F]
			"
		>
			<View
				accessibilityElementsHidden
				className="
					w-20 h-20 rounded-full flex items-center justify-center
					bg-light-surface-secondary dark:bg-white/[0.04]
				"
			>
				<UserPlus size={32} strokeWidth={1.5} color="#888d96" />
			</View>
			<View className="flex flex-col gap-xs max-w-[360px] items-center">
				<Text className="font-sans font-bold text-title text-light-text-primary dark:text-white text-center">
					Pick a contact
				</Text>
				<Text className="font-sans text-footnote text-light-text-secondary dark:text-white/55 text-center">
					Their profile, shared chats, and quick actions show up here.
				</Text>
			</View>
			<Pressable
				accessibilityRole="button"
				accessibilityLabel="Add a new contact"
				onPress={onAddContact}
				// `transition-opacity` dropped — NativeWind has no CSS
				// transition driver.
				className="
					bg-light-accent-sky
					px-lg py-sm rounded-pill
					hover:opacity-90 active:opacity-80
				"
			>
				<Text className="font-sans text-footnote font-semibold text-white">
					Add a new contact
				</Text>
			</Pressable>
		</View>
	);
}
